export default {
      id: "icon-print-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-print",
      toString: function () {
        return this.url;
      }
    }